"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDate = exports.newArrayOfObjects = exports.thumbnailFilenameFromFilename = exports.processDecimal = exports.isEmptyString = exports.generateRandomId = exports.isObjectStrict = exports.round = exports.lowercaseComparison = exports.lowercaseValues = exports.lowercaseKeys = exports.pruneEmpty = exports.settingsDiff = exports.getParameterCaseInsensitive = exports.insertIf = exports.defaultVoidFunc = exports.fileSizeCheck = exports.sanitizeFilename = exports.getUnitPreference = exports.toTitleCase = exports.nRandomNumberString = exports.containsObject = exports.replaceAll = void 0;
const isUndefined_1 = __importDefault(require("lodash/isUndefined"));
const isNull_1 = __importDefault(require("lodash/isNull"));
const isNaN_1 = __importDefault(require("lodash/isNaN"));
const isString_1 = __importDefault(require("lodash/isString"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const keys_1 = __importDefault(require("lodash/keys"));
const values_1 = __importDefault(require("lodash/values"));
const pull_1 = __importDefault(require("lodash/pull"));
const forOwn_1 = __importDefault(require("lodash/forOwn"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const toLower_1 = __importDefault(require("lodash/toLower"));
const object_path_1 = __importDefault(require("object-path"));
const sanitize_filename_1 = __importDefault(require("sanitize-filename"));
const moment_1 = __importDefault(require("moment/moment"));
const validation_1 = require("../validation");
const transformation_1 = require("./transformation");
const replaceAll = (string, toReplace, replacement) => {
    return string.replace(new RegExp(`${toReplace}`, "g"), replacement);
};
exports.replaceAll = replaceAll;
// Checks if the given Array contains the given Object
const containsObject = (obj, arr) => {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === obj)
            return true;
    }
    return false;
};
exports.containsObject = containsObject;
const nRandomNumberString = (n) => {
    const arr = Array.from({ length: n }, () => Math.floor(Math.random() * n));
    const str = (0, exports.replaceAll)(arr.toString(), ",", "");
    return str.slice(0, n);
};
exports.nRandomNumberString = nRandomNumberString;
const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    });
};
exports.toTitleCase = toTitleCase;
// Takes a unit as "imperial" or "metric" and returns the unit preference
const getUnitPreference = (unit) => validation_1.UnitPreferences[(0, toLower_1.default)(unit)];
exports.getUnitPreference = getUnitPreference;
const sanitizeFilename = (filename) => {
    let sanitizedFilename = filename;
    // remove spaces
    sanitizedFilename = (0, exports.replaceAll)(sanitizedFilename, " ", "_");
    // remove parentheses
    sanitizedFilename = (0, exports.replaceAll)(sanitizedFilename, "[()]", "");
    // remove directory paths and invalid characters
    return (0, sanitize_filename_1.default)(sanitizedFilename);
};
exports.sanitizeFilename = sanitizeFilename;
const fileSizeCheck = (file, maxFileSizeMb, alertCallback) => {
    console.log("Performing File Size check");
    const fileSizeMb = file.size / 1000000;
    if (fileSizeMb > maxFileSizeMb) {
        if (alertCallback)
            alertCallback();
        return false;
    }
    return true;
};
exports.fileSizeCheck = fileSizeCheck;
// eslint-disable-next-line @typescript-eslint/no-empty-function
const defaultVoidFunc = () => { };
exports.defaultVoidFunc = defaultVoidFunc;
const insertIf = (condition, arrayOrObj) => {
    if (Array.isArray(arrayOrObj))
        return condition ? arrayOrObj : [];
    return condition ? arrayOrObj : {};
};
exports.insertIf = insertIf;
// get the value of an object for the given key (case-insensitive)
const getParameterCaseInsensitive = (object, key) => {
    const asLowercase = key.toLowerCase();
    const foundKey = Object.keys(object).find((k) => k.toLowerCase() === asLowercase);
    return foundKey ? object[foundKey] : undefined;
};
exports.getParameterCaseInsensitive = getParameterCaseInsensitive;
const settingsDiff = (newSettings, originalSettings, ignoreList = []) => {
    // ignore_list takes a list of (str) keys to ignore
    // Returns an object with the keys/values that have changed from their initial state
    const _newSettings = (0, cloneDeep_1.default)(newSettings);
    const _originalSettings = (0, cloneDeep_1.default)(originalSettings);
    // Deleting ignored fields
    ignoreList.forEach((ignore_attribute) => {
        if (object_path_1.default.has(_newSettings, ignore_attribute)) {
            object_path_1.default.del(_newSettings, ignore_attribute);
        }
        if (object_path_1.default.has(_originalSettings, ignore_attribute)) {
            object_path_1.default.del(_originalSettings, ignore_attribute);
        }
    });
    // calculating changed settings
    const changedSettings = {};
    Object.keys(_newSettings).forEach((setting) => {
        const newSetting = _newSettings[setting];
        const originalSetting = _originalSettings[setting];
        if ((0, exports.isObjectStrict)(newSetting)) {
            if (!(0, isEqual_1.default)(originalSetting, newSetting))
                changedSettings[setting] = newSetting;
        }
        else if ((0, isArray_1.default)(newSetting)) {
            if (!(0, isEqual_1.default)(originalSetting, newSetting))
                changedSettings[setting] = newSetting;
        }
        else if (originalSetting !== newSetting) {
            changedSettings[setting] = newSetting;
        }
    });
    return { changed: Object.keys(changedSettings).length > 0, changedSettings };
};
exports.settingsDiff = settingsDiff;
const pruneEmpty = (obj) => {
    return (function prune(current) {
        (0, forOwn_1.default)(current, function (value, key) {
            if ((0, isUndefined_1.default)(value) ||
                (0, isNull_1.default)(value) ||
                (0, isNaN_1.default)(value) ||
                value === 0 ||
                ((0, isString_1.default)(value) && (0, isEmpty_1.default)(value)) ||
                ((0, isObject_1.default)(value) && (0, isEmpty_1.default)(prune(value)))) {
                delete current[key];
            }
        });
        // remove any leftover undefined values from the delete
        // operation on an array
        if ((0, isArray_1.default)(current))
            (0, pull_1.default)(current, undefined);
        return current;
    })((0, cloneDeep_1.default)(obj)); // Do not modify the original object, create a clone instead
};
exports.pruneEmpty = pruneEmpty;
// transforms an array or object to an array of lowercase keys
const lowercaseKeys = (arrayOrObj) => {
    return Array.isArray(arrayOrObj)
        ? arrayOrObj.map((item) => (0, toLower_1.default)(item))
        : (0, keys_1.default)(arrayOrObj).map((item) => (0, toLower_1.default)(item));
};
exports.lowercaseKeys = lowercaseKeys;
const lowercaseValues = (obj) => (0, values_1.default)(obj).map((value) => (0, toLower_1.default)(value));
exports.lowercaseValues = lowercaseValues;
// validate a string value against a limit. The limit can be a string, array or object.
const lowercaseComparison = (value, limit) => {
    // if limit is a string, then it's a single key to compare
    if (typeof limit === "string")
        return (0, toLower_1.default)(limit) === (0, toLower_1.default)(value);
    // if limit is an array or obj, then it's a list of keys to compare
    return (0, exports.lowercaseKeys)(limit).includes((0, toLower_1.default)(value));
};
exports.lowercaseComparison = lowercaseComparison;
const round = (value, precision) => {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
};
exports.round = round;
// strictly checks if the variable is an Object. Passing in an Array will return false
const isObjectStrict = (variable) => typeof variable === "object" && variable !== null && !Array.isArray(variable);
exports.isObjectStrict = isObjectStrict;
/** Generates a random firebase style ID (20 chars)
 * {@link https://firebase.blog/posts/2015/02/the-2120-ways-to-ensure-unique_68}
 * **/
const generateRandomId = () => {
    const PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
    let lastPushTime = 0;
    const lastRandChars = [];
    return (() => {
        let now = new Date().getTime();
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        const timeStampChars = new Array(8);
        let i;
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            now = Math.floor(now / 64);
        }
        if (now !== 0)
            throw new Error("We should have converted the entire timestamp.");
        let id = timeStampChars.join("");
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        if (id.length != 20)
            throw new Error("Length should be 20.");
        return id;
    })();
};
exports.generateRandomId = generateRandomId;
const isEmptyString = (string) => string.trim() === "";
exports.isEmptyString = isEmptyString;
const processDecimal = (value) => {
    const decimal = value.toFixed(1).split(".")[1];
    return Number(decimal) !== 0 ? value.toFixed(1) : value.toFixed(1).split(".")[0];
};
exports.processDecimal = processDecimal;
const thumbnailFilenameFromFilename = (filename, imageAngle, thumbnailSize) => {
    const thumbnailFilename = (0, transformation_1.getTransformationImageFilename)(filename, imageAngle, thumbnailSize);
    return thumbnailFilename.replace(`${imageAngle}_`, "");
};
exports.thumbnailFilenameFromFilename = thumbnailFilenameFromFilename;
// creates a new Array of Objects from an existing one
// used to remove both Array and Object references
const newArrayOfObjects = (l) => l.map((o) => (Object.assign({}, o)));
exports.newArrayOfObjects = newArrayOfObjects;
const getFormattedDate = (date, dateFormat = validation_1.defaultDateFormat, retType = "str") => {
    // processes the date to remove timezone offsets
    // retType : "str" or "moment"
    const offsetDate = new Date((0, moment_1.default)(date).toDate().getTime() - (0, moment_1.default)(date).toDate().getTimezoneOffset() * 60000);
    return retType === "str" ? (0, moment_1.default)(offsetDate).format(dateFormat) : (0, moment_1.default)(offsetDate);
};
exports.getFormattedDate = getFormattedDate;
//# sourceMappingURL=helpers.js.map